
function updateWishlistCounter() {

    const iconHeader = document.querySelector(".favorite-header");
    const counter = document.querySelector(".wishlist-count");

    const isFavorite = App.wishlist.count();

    iconHeader.src = isFavorite > 0
    ? iconHeader.dataset.filled
    : iconHeader.dataset.empty;

    if (!counter) return;

    counter.textContent = App.wishlist.count();

}

updateWishlistCounter();

document.addEventListener("wishlist:updated", updateWishlistCounter);